import 'choerodon-ui/lib/style/index.less';
import './index.less';
// style dependencies
import 'choerodon-ui/lib/trigger/style';
import '../../button/style';
